<template>
     <!-- 结果报表 -->
    <div class="strategy_tab_result" v-show="activeName == 'second'">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="id" label="ID倒序" align="center"></el-table-column>
        <el-table-column label="日期" align="center">
          <template slot-scope="scope">{{timestampToTime(scope.row.createTime)}}</template>
        </el-table-column>
        <!-- <el-table-column prop="name" label="测试用例文件 打开 或下载" align="center">
          <template>
            <span>打开</span>
            <span>下载</span>
          </template>
        </el-table-column>-->
        <el-table-column  label="用例对象" align="center">
          <template slot-scope="scope">
            <p v-for="item in scope.row.createXcXpData" :key="item.id">
              {{item.projectName}}
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="remark" :label="this.$t('title.Remark')" align="center"></el-table-column>
        <el-table-column :label="$t('title.state')" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.status ? '通过' : '未通过'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="商城订单文件csv" align="center">
          <template slot-scope="scope">
            <el-button type="primary" @click="getStrategyViews(scope.row.csvUrl, 'csv')">下载</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="测试日志" align="center">
          <template slot-scope="scope">
            <el-button type="primary" @click="getStrategyViews(scope.row.reportUrl, 'txt')">下载</el-button>
            <!-- <span  style="display:inline-block;margin-left:10px;">下载</span> -->
          </template>
        </el-table-column>
        <el-table-column prop="address" label="测试报告" align="center">
          <template slot-scope="scope">
            <el-button type="primary" @click="getStrategyExport(scope.row.key)">下载</el-button>
            <!-- <span  style="display:inline-block;margin-left:10px;">下载</span> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="currentPageChange"
        :current-page="page"
        :page-size="pageNum"
        layout="total,prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
</template>
<script>
import {
  getStrategyShow,
  getStrategyView,
  exportReport
} from "@/api/interface";
export default {
  props:['activeName', 'environment'],
  data() {
    return {
      tableData: [], //报表
      page: 1,
      total: 0,
      pageNum: 10,
    }
  },
  created() {
    this.getStrategyShows();
  },
   watch: {
    //切换到报表页面拉去数据
    activeName(val) {
      if (val == "second") {
        this.getStrategyShows();
      }
    },
  },
  methods: {
        //获取报表数据
    getStrategyShows() {
      const data = {
        pageNum: this.pageNum,
        page: this.page,
      };
      getStrategyShow(data, this.environment.http).then(res => {
        const data = JSON.parse(res.data);
        this.total = data.total;
        this.tableData = data.strategyList;
        // this.paddingTableData = this.tableData.map(v => {
        //   v.createSpecData = JSON.parse(v.createSpecData);
        //   v.createUserData = JSON.parse(v.createUserData);
        //   v.createXcXpData = JSON.parse(v.createXcXpData);
        //   return v;
        // });
      });
    },
      //打开或下载文件
    getStrategyViews(url, fileType) {
      if (url != null) {
        const data = {
          url,
          fileType
        };
        getStrategyView(data, this.environment.http).then(res => {
          location.href = res.data;
        });
      } else {
        this.$message.error("暂无日志");
      }
    },
    getStrategyExport(key) {
      exportReport(this.environment.http, key).then(res => {
        location.href = res.data;
      });
    },
      //分页
    currentPageChange(e) {
      this.page = e;
      console.log(e, 9999);
      this.getStrategyShows(this.pageNum, this.page);
    },
  }
}
</script>
<style scoped lang="scss">

</style>